import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	CreatePersonTaxInformationDto,
	GetPersonTaxInformationRes,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const createPersonTaxInfoRequest = async ({
	personId,
	body,
}: {
	personId: string;
	body: CreatePersonTaxInformationDto;
}): Promise<GetPersonTaxInformationRes | null> => {
	return await makeRequest<ApiV1.Response<GetPersonTaxInformationRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_TAX_POST, {
			personId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const updatePersonTaxInfoRequest = async ({
	personId,
	taxId,
	body,
}: {
	personId: string;
	taxId: string;
	body: CreatePersonTaxInformationDto;
}): Promise<GetPersonTaxInformationRes | null> => {
	return await makeRequest<ApiV1.Response<GetPersonTaxInformationRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_TAX_TAXID_PUT, {
			personId,
			taxId,
		}),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const deletePersonTaxInfoRequest = async ({
	personId,
	taxId,
}: {
	personId: string;
	taxId: string;
}): Promise<GetPersonTaxInformationRes | null> => {
	return await makeRequest<ApiV1.Response<GetPersonTaxInformationRes>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_TAX_TAXID_DELETE, {
			personId,
			taxId,
		}),
		method: HTTP_METHOD.DELETE,
	}).then((response) => response.payload ?? null);
};
